import { FC, useState, useEffect } from "react";
import TableComponent from "../../../common/TableComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/ConfigureStore";
import {
  useAppSelector,
  useAppDispatch,
} from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { usePumpFacade } from "../../../../facade/calculation/calculation-output/pump.facade";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import {
  PumpCalcModel,
  Equipment,
} from "../../../../store/model/calculations/calculation";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
interface PumpListProps { }

const PumpList: FC<PumpListProps> = () => {
  const dispatch = useAppDispatch();
  const pumpList = useSelector((state: RootState) => state.pump.PumpList);
  const equipments = useSelector((state: RootState) => state.pump.Equipments);
  const equipmentsBOH = useSelector(
    (state: RootState) => state.pump.BOHEquipments
  );
  const selectedESPPumpEquipments = useSelector(
    (state: RootState) => state.pump.ESPEquipments
  );
  const selectedESPBOHEquipments = useSelector(
    (state: RootState) => state.pump.ESPEquipmentsBOH
  );
  const selectedPumpId = useSelector(
    (state: RootState) => state.tubing?.tab1Input?.hiddenPumpID
  );
  const selectedPump = pumpList.find((pump) => pump.pumpID === selectedPumpId);

  const [showRowDetails, setShowRowDetails] = useState(false);
  const [pumpName, setPumpName] = useState("");
  const [parentId, setParentId] = useState("");
  const [maxEquipmentLimit, setMaxEquipmentLimit] = useState(7);
  const [details, setDetails] = useState<{ noStgs: any }[]>([]);
  const [equipmentsWithIndex, setEquipmentsWithIndex] = useState<
    { index: number; equipments: any[] }[]
  >([]);

  const {
    GetPumpEquipments,
    updateHiddenPumpId,
    updateSelectedPump,
    updateESPEquipmentsForPumps,
    updateESPEquipmentsForBOH,
    updateFilteredEquipments,
    updatePumpDesrdStges,
    triggerShaftTypeForPump
  } = usePumpFacade();

  const { updatehdnPumpHousinType,updateHdnPumpShaftType} = useTubingFacade();
  const { updateSchematicEquipmentData } = useCalculationFacade();

  const {
    existedSRGasPump3Equipments,
    existedSRGasPump2Equipments,
    existedSRGasPump1Equipments,
  } = useSelector(
    (state: RootState) => state.gasCalculations
  );
  const { pumpListCollapse, pumpBOHCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const { updatePumpListCollapse, updateBOHCollapse } = useCollapseFacade();
  useEffect(() => {
    if (selectedPump) {
      updateSelectedPump(selectedPump);
    }
  }, [selectedPump]);


  const handleRowClick = (pump: PumpCalcModel) => {
    if (!pump) return;
    if (selectedPumpId !== pump.pumpID) {
      updateESPEquipmentsForPumps([{}]);
      updateSchematicEquipmentData();
    }

    setParentId(pump?.pumpID);
    updateHiddenPumpId(pump.pumpID);
    updateSelectedPump(pump);
    updatehdnPumpHousinType(pump?.housingType === "STD" ? "0" : "1");
    GetPumpEquipments();
    triggerShaftTypeForPump();
  };


  const onRowExpand = (event: {
    data: { pumpName: string; pumpID: string };
  }) => {
    setShowRowDetails(true);
    setPumpName(event.data?.pumpName);
    handleRowClick(event.data as PumpCalcModel);
  };


  const handleOnClearEquipment = (id: string, index: number) => {
    const duplicateEsPEquipments = [...selectedESPPumpEquipments];
    const filteredDetails = duplicateEsPEquipments
      ?.splice(index)
      ?.filter((x: { id: string | null }) => x.id !== "" && x.id !== null)
      .map((detail: { [key: string]: any }) => ({ ...detail }));
    const shaftType =
    duplicateEsPEquipments[duplicateEsPEquipments.length-1]?.shaftType === "STD" ? 0 : 1;
    updateHdnPumpShaftType(shaftType.toString());

    updateESPEquipmentsForPumps(duplicateEsPEquipments);
    updateSchematicEquipmentData();
    if (duplicateEsPEquipments.length > 0) {
      const totalStgs = duplicateEsPEquipments.reduce((sum, equipment) => sum + (equipment.noStgs || 0), 0);
      updatePumpDesrdStges(totalStgs);
    }
  };

  const BOHEquipmentsClear = () => {
    updateESPEquipmentsForBOH([]);
    updateSchematicEquipmentData();
  };

  const handleSelectedBOHPumpEquipments = (option: any, index: number) => {
    updateSchematicEquipmentData();
  };

  useEffect(() => {
    if (equipments.length > 0) {
      setEquipmentsWithIndex([{ index: 0, equipments }]);
    }
  }, [equipments]);

  useEffect(() => {
    if (equipments.length > 0 && selectedESPPumpEquipments.length > 0) {
      const filtered = selectedESPPumpEquipments
        .map((item: any, index: number, arr: any[]) => {
          const prevItem = index === 0 ? null : arr[index - 1];
          const filterStg = prevItem?.noStgs ?? 0;

          const filteredEquipments =
            index === 0
              ? equipments
              : equipments.filter((eq) => (eq.noStgs ?? 0) >= filterStg);

          return {
            index,
            equipments: filteredEquipments,
          };
        })
        .filter(Boolean);

      setEquipmentsWithIndex(filtered);
    }
  }, [equipments, selectedESPPumpEquipments]);

  const handleSelectedESPPumpEquipments = (option: any, index: number) => {
    const shaftType =
    option?.shaftType === "STD" ? 0 : 1;
    updateHdnPumpShaftType(shaftType.toString());
    let updatedArray = [...selectedESPPumpEquipments];
    if (updatedArray[index]) {
      const existingItem = updatedArray[index];
      const isDifferent = JSON.stringify(existingItem) !== JSON.stringify(option);
      if (isDifferent) {
        updatedArray[index] = option;
      }
    } else {
      const emptyIndex = updatedArray.findIndex(
        (item) => Object.keys(item).length === 0
      );

      if (emptyIndex !== -1) {
        updatedArray[emptyIndex] = option;
      } else {
        updatedArray[index] = option;
      }
      if (updatedArray.length < maxEquipmentLimit) {
        updatedArray.push({});
      }

    }
    const nonEmptyItems = updatedArray.filter(
      (x: { id: string | null }) => x.id !== "" && x.id !== null
    );

    updateESPEquipmentsForPumps(updatedArray);

    updateSchematicEquipmentData();

    const newDetails = [...updatedArray];
    const selectedStage = updatedArray[index]?.noStgs || 0;
    newDetails[index] = { noStgs: selectedStage };
    setDetails(newDetails);

    const filteredEquipments = getFilteredSRPumps(
      index,
      equipments,
      newDetails
    );
    const newEquipmentsWithIndex = [...equipmentsWithIndex];
    newEquipmentsWithIndex[index + 1] = {
      index: index + 1,
      equipments: filteredEquipments,
    };
    setEquipmentsWithIndex(newEquipmentsWithIndex);
    const updatedOptions = newEquipmentsWithIndex[index]?.equipments.map(
      (item: any) => {
        return {
          ...item,
          label: item?.pN_Description,
          value: item?.id,
        };
      }
    );

    updateFilteredEquipments(updatedOptions);

    if (updatedArray.length > 0) {
      const totalStgs = updatedArray.reduce((sum, equipment) => sum + (equipment.noStgs || 0), 0);
      updatePumpDesrdStges(totalStgs);
    }
  };

  useEffect(() => {
    if (selectedESPBOHEquipments?.length > 0) {
      const lastEquipment =
        selectedESPBOHEquipments[selectedESPBOHEquipments.length - 1];
      if (lastEquipment?.parentId === parentId) {
        setParentId(lastEquipment.parentId);
      }
    }
  }, [selectedESPBOHEquipments, parentId]);

  useEffect(() => {
    let updatedEquipments = [...selectedESPPumpEquipments];
    if (updatedEquipments.length > maxEquipmentLimit) {
      updatedEquipments = updatedEquipments
        .slice(0, maxEquipmentLimit)
        .filter((item) => Object.keys(item).length > 0);
      while (updatedEquipments.length < maxEquipmentLimit) {
        updatedEquipments.push({});
      }

      updateESPEquipmentsForPumps(updatedEquipments);
    }
    if (
      updatedEquipments.length < maxEquipmentLimit &&
      !updatedEquipments.some((item: any) => Object.keys(item).length === 0)
    ) {
      updateESPEquipmentsForPumps([...updatedEquipments, {}]);
    }
  }, [maxEquipmentLimit, selectedESPPumpEquipments]);



  const getFilteredSRPumps = (index: any, equipments: any, details: any) => {
    if (!equipments || !Array.isArray(equipments)) return [];

    return equipments.filter((equipment) => {
      return details[index]?.noStgs <= equipment.noStgs;
    });
  };

  useEffect(() => {
    const chargePumps = [
      ...existedSRGasPump3Equipments,
      ...existedSRGasPump2Equipments,
      ...existedSRGasPump1Equipments,
    ];
    const countWithValues = chargePumps.filter((pump) => pump).length;

    let limit = 7;
    if (countWithValues === 3) limit = 4;
    else if (countWithValues === 2) limit = 5;
    else if (countWithValues === 1) limit = 6;

    setMaxEquipmentLimit((prevLimit) => {
      if (prevLimit !== limit) {
        return limit;
      }
      return prevLimit;
    });
  }, [
    existedSRGasPump1Equipments,
    existedSRGasPump2Equipments,
    existedSRGasPump3Equipments,
  ]);


  const tableData = pumpList;

  const tableColumns = [
    { key: "pumpName", title: "Pumps", dataIndex: "pumpName" },
    {
      key: "minimumOperatingBPD",
      title: "Min (bpd)",
      dataIndex: "minimumOperatingBPD",
    },
    { key: "bepFlow", title: "BEP (bpd)", dataIndex: "bepFlow" },
    {
      key: "maximumOperatingBPD",
      title: "Max (bpd)",
      dataIndex: "maximumOperatingBPD",
    },
    {
      key: "liftPerStage",
      title: "Lift/Stage (ft)",
      dataIndex: "liftPerStage",
    },
    {
      key: "bhpPerStage",
      title: "Power/Stage (hp)",
      dataIndex: "bhpPerStage",
    },
    {
      key: "effeciency",
      title: "Eff (%)",
      dataIndex: "effeciency",
    },
    {
      key: "numberOfStages",
      title: "Num Stages",
      dataIndex: "numberOfStages",
    },
    { key: "totalBHP", title: "Power Total (hp)", dataIndex: "totalBHP" },

    {
      key: "standardShaftHPLimit",
      title: " Std Shaft Power Limit (hp) ",
      dataIndex: "standardShaftHPLimit",
    },

    {
      key: "hsShaftHPLimit",
      title: "HS Shaft Power Limit (hp)",
      dataIndex: "hsShaftHPLimit",
    },
    {
      key: "shaftDiameter",
      title: "Shaft Dia (in)",
      dataIndex: "shaftDiameter",
    },
    { key: "pumpImpellar", title: "Impeller Type", dataIndex: "pumpImpellar" },
  ];

  const equipmentColumns = [
    { key: "equipment", title: "Equipment", dataIndex: "equipment" },
    { key: "pn", title: "PN", dataIndex: "pn" },
    { key: "length", title: "Length (ft)", dataIndex: "length" },
    { key: "weight", title: "Weight (lbs)", dataIndex: "weight" },
    { key: "diameter", title: "Diameter (in)", dataIndex: "diameter" },
    { key: "setDepth", title: "Set depth (ft)", dataIndex: "setDepth" },
  ];

  const handleCollapseChange = (key: boolean, name: string) => {
    if (name === "pumpList") updatePumpListCollapse(key);
    else if (name === "boh") updateBOHCollapse(key);
  };

  return (
    <>
      <Accordion
        title='Pumps list @ 60Hz'
        text={"No. of records: " + pumpList?.length}
        isOpen={pumpListCollapse}
        onToggle={() => handleCollapseChange(!pumpListCollapse, "pumpList")}
        content={
          <div className='items-center mb-[20px] space-y-4 md:space-y-0 p-4'>
            <TableComponent
              name={"pumpList"}
              data={tableData}
              singleExpandMode={true}
              rowsPerPage={5}
              columns={tableColumns}
              clickableRows={true}
              hiddenPumpId={selectedPumpId}
              emptyIcon={true}
              pagination={false}
              onRowClick={handleRowClick}
              height={465}
              overFlowClass='overflow-auto'
              renderExpandedRow={(row, rowIndex) =>
                row.errorMessage ? (
                  <div className='p-2 text-red-500 bg-red-200 rounded'>
                    {row.errorMessage}
                  </div>
                ) : equipments?.length > 0 ? (
                  <EquipmentTableAddChargePump
                    isPumpListMode={true}
                    options={equipmentsWithIndex}
                    equipments={
                      selectedESPPumpEquipments?.length > 0
                        ? selectedESPPumpEquipments
                        : [{}]
                    }
                    onClear={(value: string, index: number) => { handleOnClearEquipment(value, index) }}
                    rowLength={maxEquipmentLimit}
                    onChange={(option: any, index: any) => {
                      handleSelectedESPPumpEquipments(option, index);
                    }}
                    equipmentGridParentContainer='SRPumps'
                    parentId={selectedPumpId}
                  />
                ) : (
                  <></>
                )
              }
            />
          </div>
        }
      />
      {equipmentsBOH.length>0 && <Accordion
        title='BOH'
        isOpen={pumpBOHCollapse}
        onToggle={() => handleCollapseChange(!pumpBOHCollapse, "boh")}
        content={
          <div className='items-center mb-[20px] space-y-4 md:space-y-0 p-4'>
            <EquipmentTableAddChargePump
              options={equipmentsBOH.map((item: any) => {
                return {
                  ...item,
                  label: item?.boh,
                  value: item?.id,
                };
              })}
              equipments={
                selectedESPBOHEquipments?.length > 0
                  ? selectedESPBOHEquipments
                  : [selectedESPBOHEquipments]
              }
              onClear={BOHEquipmentsClear}
              rowLength={equipmentsBOH?.length > 1 ? 2 : 1}
              onChange={handleSelectedBOHPumpEquipments}
              equipmentGridParentContainer='SRBOH'
            />
          </div>
        }
      />
    }
    </>
  );
};

export default PumpList;
